import * as Yup from "yup";
import { validatorStringTextOnly } from "../validatorStringTextOnly";
import { getValidatorAddressStreet } from "./validatorAddressStreet";
import { getValidatorPostalCode } from "./validatorPostalCode";
import { validatorRegion } from "./validatorRegion";

export const getValidationSchemaAddress = (
  country: string,
  options?: {
    allowPOBox?: boolean;
  }
) => {
  const validatorAddressStreet = getValidatorAddressStreet(options?.allowPOBox);

  return Yup.object().shape({
    addressLine1: validatorAddressStreet.required("Required"),
    addressLine2: validatorAddressStreet,
    city: validatorStringTextOnly.required("Required"),
    state: validatorRegion(country),
    postalCode: getValidatorPostalCode(country)
  });
};
